import * as z from "zod";
export const TextDiffViewer = z.object({
    type: z.literal("text_diff_viewer"),
    value: z.object({
        original: z.string(),
        modified: z.string(),
        language: z.string().optional(),
    }),
});
